import styled from "styled-components";

export const ContainerCupom = styled.section`
    width: 100%;
    max-width: 1145px;
    margin: 5rem auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
`;

export const Header = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    text-align: left;
    gap: 1rem;
    @media (max-width: 768px) {
        text-align: center;
        gap: 2rem;
    }
`;

export const TitleCupom = styled.h2`
    color: var(--c-brand-accent);
    font-family: "Lato", sans-serif;
    font-weight: 900;
    font-size: 32px;
    border-right: 2px solid var(--c-brand-accent);
    padding-right: 16px;

    @media (max-width: 767px) {
        border: none;
        text-align: center;
        font-size: 26px;
        border-right: none;
    }
    @media (max-width: 1024px) and (min-width: 768px) {
        text-align: center;
        font-size: 26px;
    }
`;

export const Description = styled.p`
    max-width: 400px;
    color: var(--c-brand-accent);
    font-family: "Lato", sans-serif;
    font-size: 18px;
    line-height: 1.4;
    @media (max-width: 768px) {
        width: 90%;
        text-align: center;
        margin-right: 20px;
    }
`;

export const StepsWrapper = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    flex-wrap: wrap;
    width: 100%;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
    }
    @media (max-width: 1024px) and (min-width: 768px) {
        width: 100%;
        justify-content: center;
    }
`;

export const Step = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1 1 22%;
    min-width: 250px;
    position: relative;
    text-align: center;

    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const Image = styled.img`
    width: 279px;
    height: 404px;
    object-fit: contain;

    @media (max-width: 768px) {
        width: 100%;
        height: auto;
    }
`;